/* eslint-disable no-unused-vars */

import {Divider} from '@mui/material';
import AppAutocompleteTextField from 'main/core/AppFormComponents/AppAutocompleteTextField';
import AppDateTimePicker from 'main/core/AppFormComponents/AppDateTimePicker';
import AppFilePicker from 'main/core/AppFormComponents/AppFilePicker';
import AppFormSection from 'main/core/AppFormComponents/AppFormSection';
import AppImageUploader from 'main/core/AppFormComponents/AppImageUploader';
import AppNumberField from 'main/core/AppFormComponents/AppNumberField';
import AppOptionField from 'main/core/AppFormComponents/AppOptionField';
import AppStarRating from 'main/core/AppFormComponents/AppStarRating';
import AppTagField from 'main/core/AppFormComponents/AppTagField';
import AppTextField from 'main/core/AppFormComponents/AppTextField';
import {UiWiseFormFieldType} from 'shared/constants/UiWiseConst';

export const getFormField = (widgetid, field) => {
  const {slotprops, labelid, multivalue, value, ...restField} = field;
  // console.log(
  //   `...[getFormField] ${widgetid}: ${field.name} -  ${field.fieldtype} - ${JSON.stringify(restField)}`,
  // );

  switch (field.fieldtype) {
    case UiWiseFormFieldType.TEXT:
      return <AppTextField {...restField} />;

    case UiWiseFormFieldType.NUMBER:
      return <AppNumberField {...restField} />;

    case UiWiseFormFieldType.DATEPICKER:
      return <AppDateTimePicker {...restField} />;

    case UiWiseFormFieldType.STARRATING:
      return <AppStarRating isForm={true} {...restField} />;

    case UiWiseFormFieldType.OPTION_FIELD:
      return (
        <AppOptionField
          widgetid={widgetid}
          multivalue={multivalue}
          {...restField}
        />
      );

    case UiWiseFormFieldType.AUTOCOMPLETE:
      return <AppAutocompleteTextField widgetid={widgetid} {...restField} />;

    case UiWiseFormFieldType.FILEPICKER:
      return <AppFilePicker fullWidth widgetid={widgetid} {...restField} />;

    case UiWiseFormFieldType.DIVIDER:
      return <Divider />;

    case UiWiseFormFieldType.SECTION:
      return <AppFormSection fullWidth title={value} />;

    case UiWiseFormFieldType.SPACER:
      return <></>; // To skip the Form Grid and leave blank space

    case UiWiseFormFieldType.IMAGEUPLOADER:
      return (
        <AppImageUploader
          fullWidth
          widgetid={widgetid}
          multivalue={multivalue}
          {...restField}
        />
      );

    case UiWiseFormFieldType.TAG:
      return <AppTagField {...restField} />;

    case UiWiseFormFieldType.HIDDEN:
    default:
      return (
        <input type='hidden' name={field.name} value={field.value || ''} />
      );
  }
};
